import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { JoinSessionVM } from '../../models/JoinSessionVM';
import { FormBuilder } from '@angular/forms';
import { CommsService } from '../../../services/comms.service';
import { JoinSessionResponseVM } from '../../models/JoinSessionResponseVM';
import { SessionType } from '../../models/SessionType';
import { SessionStatus } from '../../models/SessionStatus';

@Component({
  selector: 'step-5-complete',
  templateUrl: './step-5-complete.component.html'
})
export class Step5CompleteComponent implements OnInit {

  redirect: string;

  @Output() OnChanged: EventEmitter<number> = new EventEmitter();

  constructor(private router: Router, private route: ActivatedRoute, private commsService: CommsService) {

  }

  ngOnInit(): void {
    var self = this;

    const sessionUrl = this.route.params
      .subscribe(params => {
        self.redirect = params['t'];
      });
  }

  setDeviceSetupStage4() {
    this.OnChanged.emit(4);
  }

  redirectToSession() {
    this.router.navigateByUrl('/' + this.redirect);
  }

}
